import { useState } from "react";
import {
  CadastrarCaracteristicasAptoDTO,
  CaracteristicasApto,
} from "../../../interfaces/CaracteristicasApto";
import { cadastrarCaracteristicasAptoService } from "../../../services/cadastrarCaracteristicasAptoService";
import { excluirCaracteristicasAptoService } from "../../../services/excluirCaracteristicasAptoService";

export const useCadastrarCaracteristicasApto = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const cadastrar = async (
    values: CadastrarCaracteristicasAptoDTO,
    caracteristicasAptoOriginais: CaracteristicasApto[]
  ) => {
    setIsLoading(true);

    try {
      const idsOriginais = caracteristicasAptoOriginais.map(
        (item) => item.caracteristicaId
      );
      const idsNovos = values.caracteristicaId;

      const idsParaAdicionar = idsNovos.filter(
        (id) => !idsOriginais.includes(id)
      );
      const itensParaRemover = caracteristicasAptoOriginais.filter(
        (item) => !idsNovos.includes(item.caracteristicaId)
      );

      await Promise.all(
        idsParaAdicionar.map((id) =>
          cadastrarCaracteristicasAptoService({
            aptoId: values.aptoId,
            caracteristicaId: id,
          })
        )
      );

      await Promise.all(
        itensParaRemover.map((item) =>
          excluirCaracteristicasAptoService(item.id)
        )
      );

      setSuccess("Caracteristicas atualizadas com sucesso!");
    } catch (error) {
      setError(
        "Nao foi possivel atualizar as caracteristicas do apartamento. Tente novamente!"
      );
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { cadastrar, isLoading, error, success, resetError, resetSuccess };
};
